// Single source of truth for permission checks on the frontend. This is UX
// only: hiding a button here never replaces the backend's require_permission
// gate, which is the actual security boundary.
// `key` may be a list: any one of them is enough (e.g. the Settings page opens for whoever can see one of its sections).
export function hasPermission(user, key) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (Array.isArray(key)) return key.some((k) => hasPermission(user, k));
  return Array.isArray(user.permissions) && (user.permissions.includes("*") || user.permissions.includes(key));
}

// The Assistance page: technicians (queue, console) and supervisors (history and reports only).
export const ASSIST_READ = ["support:handle", "support:view_all"];

// Every permission that opens at least one section of Paramètres (sidebar entry and the /settings shell).
export const SETTINGS_ACCESS = [
  "settings:view", "whatsapp:view", "whatsapp:manage", "system:view", "page:google_sheet", "assistant:view_usage",
  "training:view_all", "training:manage_all", "training:manage_catalog", "automation:view", "automation:manage_agents",
];
// Every permission that opens something in the single Corbeille page: the `<module>:delete` key of each resource wired in backend/deletion/wiring.py
// (a test keeps both lists identical — add the key here when a resource is wired).
export const TRASH_ACCESS = [
  "tasks:delete", "prospects:delete", "prospects:delete_pilot", "customers:delete", "tickets:delete", "product:delete", "governance:delete", "knowledge:delete", "marketing:delete", "procurement:delete", "records:delete", "training:delete", "missions:delete", "equipment:delete", "finance:delete", "billing:delete", "collaborators:delete", "services:delete", "skills:delete", "roles:manage", "prospects:delete_interaction", "google_sheet:delete_submission", "support:delete_note",
];
export const WHATSAPP_ACCESS = ["whatsapp:view", "whatsapp:manage"];
